import { toast } from "react-toastify";
import { MID_SESSION} from "../../constants/constants";
import { getMidSession } from "../thunk";
import { fetchdeleteMidSessionFailure, fetchdeleteMidSessionSuccess } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const deleteMidSession = (id, setLoading, navigate) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${MID_SESSION}/${id}`, 'DELETE').then((response) => {
        if (!response.error) {
            dispatch(fetchdeleteMidSessionSuccess(response))
            setLoading(false)
            dispatch(getMidSession(setLoading))
            toast.success(`Mid Session Configuration Deleted Successfully`)
        }
        if (response.error) {
            dispatch(fetchdeleteMidSessionFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}